export interface CompareSpecRow {
    displayLabel: string;
    uiGroup: string;
    categoryKey: string;
    subCategoryKey: string;
    dataKey: string;
}

/** Source: `value to cateogry - Sheet1.csv` (Main/Sub/Spec/Category To Show). Regenerate if the sheet changes. */
export const COMPARE_SPEC_ROWS: CompareSpecRow[] = [
    {
        displayLabel: "Make",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "vehicle_identity",
        dataKey: "make",
    },
    {
        displayLabel: "Model",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "vehicle_identity",
        dataKey: "model",
    },
    {
        displayLabel: "Production Year",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "production_detail",
        dataKey: "production_year",
    },
    {
        displayLabel: "Vehicle Type",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "vehicle_type",
        dataKey: "vehicle_type",
    },
    {
        displayLabel: "Wheelbase (mm)",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "dimensions",
        dataKey: "wheelbase",
    },
    {
        displayLabel: "Width (mm)",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "dimensions",
        dataKey: "width",
    },
    {
        displayLabel: "Length (mm)",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "dimensions",
        dataKey: "length",
    },
    {
        displayLabel: "Height (mm)",
        uiGroup: "General",
        categoryKey: "1_basic_vehicle_information",
        subCategoryKey: "dimensions",
        dataKey: "height",
    },
    {
        displayLabel: "Engine Type",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "engine_type",
    },
    {
        displayLabel: "Horse Power (hp)",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "horse_power",
    },
    {
        displayLabel: "Torque (N.M)",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "torque",
    },
    {
        displayLabel: "Engine Configuration",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "engine_configuration_and_layout",
    },
    {
        displayLabel: "Displacement (L)",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "displacement (L)",
    },
    {
        displayLabel: "Cylinder Count And Arrangement",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "cylinder_count_and_arrangement",
    },
    {
        displayLabel: "Driving Range (km)",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "driving_range",
    },
    {
        displayLabel: "Forced Induction",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "engine_specifications",
        dataKey: "forced_induction_and_advanced_technologies",
    },
    {
        displayLabel: "Manual Transmission",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "transmission_optioins",
        dataKey: "manual_transmission",
    },
    {
        displayLabel: "Automatic Transmissions",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "transmission_optioins",
        dataKey: "automatic_transmissions",
    },
    {
        displayLabel: "Continuously Variable Transmission",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "transmission_optioins",
        dataKey: "continuously_variable_transmission",
    },
    {
        displayLabel: "Specialized Transmissions For Evs",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "transmission_optioins",
        dataKey: "specialized_transmission_for_EVs",
    },
    {
        displayLabel: "Drive Mode",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "transmission_optioins",
        dataKey: "drive_mode",
    },
    {
        displayLabel: "Additional Features",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "transmission_optioins",
        dataKey: "additional_features",
    },
    {
        displayLabel: "Basic Drivetrain Layouts",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "drivetrain_configurations",
        dataKey: "basic_drivetrain_layouts",
    },
    {
        displayLabel: "Advanced Drivetrain Systems",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "drivetrain_configurations",
        dataKey: "advanced_drivetrain_systems",
    },
    {
        displayLabel: "Additional Performance Features",
        uiGroup: "Performance",
        categoryKey: "2_engine_and_powertrain_options",
        subCategoryKey: "performance_enhancements",
        dataKey: "ddditional_performance_features",
    },
    {
        displayLabel: "Front Suspension",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "suspension_systems",
        dataKey: "front_suspension",
    },
    {
        displayLabel: "Rear Suspension",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "suspension_systems",
        dataKey: "rear_suspension",
    },
    {
        displayLabel: "Adaptive Suspension And Dampers",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "suspension_systems",
        dataKey: "adaptive_suspension_and_dampers",
    },
    {
        displayLabel: "Alternative Suspension Systems",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "suspension_systems",
        dataKey: "alternative_suspension_systems",
    },
    {
        displayLabel: "Steering Type",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "steering_options",
        dataKey: "standard_steering_systems",
    },
    {
        displayLabel: "All Wheel Steering",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "steering_options",
        dataKey: "all_wheel_steering",
    },
    {
        displayLabel: "Brake Type",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "brake_systems",
        dataKey: "brake_type",
    },
    {
        displayLabel: "Brake Assist Features",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "brake_systems",
        dataKey: "performance_brake_systems",
    },
    {
        displayLabel: "Open Differentials",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "open_differentials",
    },
    {
        displayLabel: "Limited Slip Differentials",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "limited_slip_differentials",
    },
    {
        displayLabel: "Electronic Limited Slip Differentials",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "electronic_limited_slip_differentials (e LSD)",
    },
    {
        displayLabel: "Torque Vectoring Differentials",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "torque_vectoring_differentials",
    },
    {
        displayLabel: "Locking Differentials",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "locking_differentials(selectable or automatic)",
    },
    {
        displayLabel: "Torsen Differentials",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "torsen(torque_sensing)differentials",
    },
    {
        displayLabel: "Active Differential Systems",
        uiGroup: "Performance",
        categoryKey: "3_suspension_steering_and_braking",
        subCategoryKey: "differential_options",
        dataKey: "active_differential_systems",
    },
    {
        displayLabel: "Airbags",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "airbags",
    },
    {
        displayLabel: "Seatbelts And Restraint Systems",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "passive_safety_features",
        dataKey: "seatbelts_and_restraint_systems",
    },
    {
        displayLabel: "Structural Safety",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "passive_safety_features",
        dataKey: "structural_safety",
    },
    {
        displayLabel: "Antilock Braking System (abs)",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "active_safety_features",
        dataKey: "antilock_braking_system",
    },
    {
        displayLabel: "Electronic Stability Control (esc)",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "active_safety_features",
        dataKey: "electronic_stability_control",
    },
    {
        displayLabel: "Traction Control System Tcs",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "active_safety_features",
        dataKey: "traction_control_system_tcs",
    },
    {
        displayLabel: "Lane Departure Warning Systems",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "lane_departure_warning_systems",
    },
    {
        displayLabel: "Cruise Control",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "adaptive_cruise_control",
    },
    {
        displayLabel:
            "Forward Collision Warning And Automatic Emergency Braking",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "forward_collision_warning_and_automatic_emergency_braking",
    },
    {
        displayLabel: "Blind Spot Monitoring",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "blind_spot_monitoring",
    },
    {
        displayLabel: "Rear Cross Traffic Alert",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "rear_cross_traffic_alert",
    },
    {
        displayLabel: "Driver Drowsiness Detection",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "driver_assistance_technologies",
        dataKey: "driver_drowsiness_detection",
    },
    {
        displayLabel: "360 Camera Systems",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "visibility_and_surveillance_systems",
        dataKey: "360_camera_systems",
    },
    {
        displayLabel: "Back Camera",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "visibility_and_surveillance_systems",
        dataKey: "back_camera",
    },
    {
        displayLabel: "Parking Assistance (sensors vision)",
        uiGroup: "Safety",
        categoryKey: "4_safety_and_driver_assistance",
        subCategoryKey: "visibility_and_surveillance_systems",
        dataKey: "parking_assistance",
    },
    {
        displayLabel: "Seat Material And Upholstery",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "seating_and_interior_configuration",
        dataKey: "seat_material_and_upholstery",
    },
    {
        displayLabel: "Seat Adjustment Options",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "seating_and_interior_configuration",
        dataKey: "seat_adjustment_options",
    },
    {
        displayLabel: "Heated Ventilated And Message Seats",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "seating_and_interior_configuration",
        dataKey: "heated_ventilated_and_message_seats",
    },
    {
        displayLabel: "Manual Climate Control",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "climate_control_and_hvac_systems",
        dataKey: "manual_climate_control",
    },
    {
        displayLabel: "Automatic Climate Control",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "climate_control_and_hvac_systems",
        dataKey: "automatic_climate_control",
    },
    {
        displayLabel: "Multi-zone Climate Control",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "climate_control_and_hvac_systems",
        dataKey: "multi_zone_climate_control",
    },
    {
        displayLabel: "Speaker Brand",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "speaker_brand",
    },
    {
        displayLabel: "Number Of Speakers",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "number_of_speakers",
    },
    {
        displayLabel: "Navigation System",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "navigation_systems",
    },
    {
        displayLabel: "Smartphone Integration",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "smartphone_integration_voice_recognition",
    },
    {
        displayLabel: "Central Display Size (inches)",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "central_display_size(inch)",
    },
    {
        displayLabel: "Passenger Display Size(inches)",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "passenger_display_size(inch)",
    },
    {
        displayLabel: "Driver Display Size(inches)",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "driver_display_size(inch)",
    },
    {
        displayLabel: "Voice Recognition And Gesture Control",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "voice_recognition_and_gesture_control",
    },
    {
        displayLabel: "Touchscreen Interfaces And Central Displays(inches)",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "infotainment_and_connectivity",
        dataKey: "touchscreen_interfaces_and_central_displays(inches)",
    },
    {
        displayLabel: "Keyless Entry And Keyless Start",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "convenience_features",
        dataKey: "keyless_entry_and_keyless_start",
    },
    {
        displayLabel: "Remote Control Functions",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "convenience_features",
        dataKey: "remote_control_functions",
    },
    {
        displayLabel: "Power Liftgate/ Trunk",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "convenience_features",
        dataKey: "power_liftgate_trunk",
    },
    {
        displayLabel: "Parking Sensors",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "convenience_features",
        dataKey: "parking_sensors",
    },
    {
        displayLabel: "Ambient Lighting",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "convenience_features",
        dataKey: "ambient_lighting",
    },
    {
        displayLabel: "Cup Holders",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "storage_and_cargo_solutions",
        dataKey: "cup_holders_and_organizers",
    },
    {
        displayLabel: "Configurable Cargo Spaces",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "storage_and_cargo_solutions",
        dataKey: "configurable_cargo_spaces",
    },
    {
        displayLabel: "Rear Seat Folding/ Adjustments",
        uiGroup: "Features",
        categoryKey: "5_interior_comfort_convenience",
        subCategoryKey: "storage_and_cargo_solutions",
        dataKey: "rear_seat_folding/_adjustments",
    },
    {
        displayLabel: "Color Options",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "exterior_styling_and_body_options",
        dataKey: "exterior_color_options_and_paint_finishes",
    },
    {
        displayLabel: "Aerodynamic Pacakges And Body Kits",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "exterior_styling_and_body_options",
        dataKey: "aerodynamic_pacakges_and_body_kits",
    },
    {
        displayLabel: "Headlight Types",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "lighting_systems",
        dataKey: "headlight_types",
    },
    {
        displayLabel: "Adaptive Headlights And High/ Low Beam Adjustments",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "lighting_systems",
        dataKey: "adaptive_headlights_and_high/_low_beam_adjustments",
    },
    {
        displayLabel: "Daytime Running Lights (drls)",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "lighting_systems",
        dataKey: "daytime_running_lights_(drls)",
    },
    {
        displayLabel: "Fog Lights",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "lighting_systems",
        dataKey: "fog_lights",
    },
    {
        displayLabel: "Tail Light Technologies",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "lighting_systems",
        dataKey: "tail_light_technologies",
    },
    {
        displayLabel: "Wheel Materials",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "wheels_tires_and_exterior_accessories",
        dataKey: "wheel_materials",
    },
    {
        displayLabel: "Tires Types and Specification",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "wheels_tires_and_exterior_accessories",
        dataKey: "tires_types_and_specification",
    },
    {
        displayLabel: "Exterior Trim and Accents",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "wheels_tires_and_exterior_accessories",
        dataKey: "exterior_trim_and_accents",
    },
    {
        displayLabel: "Electrically Adjustable/Folding Mirrors",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "mirrors_and_windows",
        dataKey: "electrically_adjustable/folding_mirrors",
    },
    {
        displayLabel: "Glass Type",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "mirrors_and_windows",
        dataKey: "glass_type",
    },
    {
        displayLabel: "Sunroof Type",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "mirrors_and_windows",
        dataKey: "sunroof_type",
    },
    {
        displayLabel: "Adaptive Headlights And High/ Low Beam Adjustments",
        uiGroup: "Features",
        categoryKey: "6_exterior_and_lighting_options",
        subCategoryKey: "lighting_systems",
        dataKey: "adaptive_headlights_and_high_low_beam_adjustments",
    },
    {
        displayLabel: "Conventional Fuels",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "fuel_options",
        dataKey: "conventional_fuels",
    },
    {
        displayLabel: "Alternative Fuels",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "fuel_options",
        dataKey: "alternative_fuels",
    },
    {
        displayLabel: "Plug-in Hybrid Electric Vehicles(phevs)",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "hybrid_powertrains",
        dataKey: "plug-in_hybrid_electric_vehicles(phevs)",
    },
    {
        displayLabel: "Battery Electric Vehicles(bevs)",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "hybrid_powertrains",
        dataKey: "battery_electric_vehicles(bevs)",
    },
    {
        displayLabel: "Fuel Cell Electric Vehicles(fcevs)",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "hybrid_powertrains",
        dataKey: "fuel_cell_electric_vehicles(fcevs)",
    },
    {
        displayLabel: "Charging Port Type",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "charging_and_energy_management",
        dataKey: "charging_port_type",
    },
    {
        displayLabel: "Regenerative Braking Systems",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "charging_and_energy_management",
        dataKey: "regenerative_braking_systems",
    },
    {
        displayLabel: "Energy Recovery Systems",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "charging_and_energy_management",
        dataKey: "energy_recovery_systems",
    },
    {
        displayLabel: "Exhaust Aftertreatment Systems",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "emission_control_technologies",
        dataKey: "exhaust_aftertreatment_systems",
    },
    {
        displayLabel: "Advanced Emissions Reduction Systems",
        uiGroup: "Performance",
        categoryKey: "7_energy_environmental_and_charging_options",
        subCategoryKey: "emission_control_technologies",
        dataKey: "advanced_emissions_reduction_systems",
    },
    {
        displayLabel: "User Interface and Connectivity Customization",
        uiGroup: "Features",
        categoryKey: "8_customization_and_personalization_options",
        subCategoryKey: "digital_and_software_personalization",
        dataKey: "user_interface_and_connectivity_customization",
    },
    {
        displayLabel: "Customizable Instrument Clusters",
        uiGroup: "Features",
        categoryKey: "8_customization_and_personalization_options",
        subCategoryKey: "digital_and_software_personalization",
        dataKey: "customizable_instrument_clusters",
    },
    {
        displayLabel: "User Interface and Connectivity Customization",
        uiGroup: "Features",
        categoryKey: "8_customization_and_personalization_options",
        subCategoryKey: "digital_and_software_personalization",
        dataKey: "user_interface_and_connectivity_customization",
    },
    {
        displayLabel: "Central Touchscreen Displays",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "infotainment_systems",
        dataKey: "central_touchscreen_displays",
    },
    {
        displayLabel: "Rear Entertainment Systems",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "infotainment_systems",
        dataKey: "rear_entertainment_systems",
    },
    {
        displayLabel: "Bluetooth and USB Connectivity",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "connectivity_features",
        dataKey: "bluetooth_and_usb_connectivity",
    },
    {
        displayLabel: "4G/5G Connectivity",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "connectivity_features",
        dataKey: "4G/5G_connectivity",
    },
    {
        displayLabel: "In-vehicle Wifi And Hotspots",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "connectivity_features",
        dataKey: "in-vehicle_wifi_and_hotspots",
    },
    {
        displayLabel: "Over-the-air Software Upgrades",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "software_and_ota_updates",
        dataKey: "over-the-air_software_upgrades",
    },
    {
        displayLabel: "User Interface and Connectivity Customization",
        uiGroup: "Features",
        categoryKey: "9_connectivity_and_infotainment_technologies",
        subCategoryKey: "digital_and_software_personalization",
        dataKey: "user_interface_and_connectivity_customization",
    },
    {
        displayLabel: "Sensor Suites",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "autonomous_driving_technologies",
        dataKey: "sensor_suites",
    },
    {
        displayLabel: "Level 2,3,4,5 Automation Features",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "autonomous_driving_technologies",
        dataKey: "level_2,3,4_and_5_automation_features",
    },
    {
        displayLabel: "Lightweight Materials",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "advanced_materials_and_construction_techniques",
        dataKey: "lightweight_materials",
    },
    {
        displayLabel: "Active Structural Technologies",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "advanced_materials_and_construction_techniques",
        dataKey: "active_structural_technologies",
    },
    {
        displayLabel: "Secure Connectivity Protocols",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "cybersecurity_and_data_privacy",
        dataKey: "secure_connectivity_protocols",
    },
    {
        displayLabel: "Data Encryption and Protection Systems",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "cybersecurity_and_data_privacy",
        dataKey: "data_encryption_and_protection_systems",
    },
    {
        displayLabel: "Communication Systems For Smart Transportation",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "vehicle_to_vehicle_and_vehicle_to_infrastructure",
        dataKey: "communication_systems_for_smart_transportation",
    },
    {
        displayLabel:
            "Integrated Apps for Navigation Entertainement and Services",
        uiGroup: "Features",
        categoryKey: "10_advanced_and_emerging_technologies",
        subCategoryKey: "in_car_applications_and_ecosystems",
        dataKey: "integrated_apps_for_navigation_entertainment_and_services",
    },
    {
        displayLabel: "4wd/4x4 Systems",
        uiGroup: "Features",
        categoryKey: "11_utility_and_commercial_options",
        subCategoryKey: "off_road_and_rugged_systems",
        dataKey: "4wd/4x4_systems",
    },
    {
        displayLabel: "Off Road Suspension and Protection Packages",
        uiGroup: "Features",
        categoryKey: "11_utility_and_commercial_options",
        subCategoryKey: "off_road_and_rugged_systems",
        dataKey: "off_road_suspension_and_protection_packages",
    },
    {
        displayLabel: "Tailgate And Ramp Options",
        uiGroup: "Features",
        categoryKey: "11_utility_and_commercial_options",
        subCategoryKey: "cargo_and_workspace_solutions",
        dataKey: "tailgate_and_ramp_options",
    },
    {
        displayLabel: "Telematics And Vehicle Tracking",
        uiGroup: "Features",
        categoryKey: "11_utility_and_commercial_options",
        subCategoryKey: "fleet_and_commercial_management",
        dataKey: "telematics_and_vehicle_tracking",
    },
    {
        displayLabel: "Trailer Sway Control",
        uiGroup: "Features",
        categoryKey: "11_utility_and_commercial_options",
        subCategoryKey: "towing_and_hauling_capabilities",
        dataKey: "trailer_sway_control",
    },
    {
        displayLabel: "4wd/4x4 Systems",
        uiGroup: "Features",
        categoryKey: "11_utility_and_commercial_options",
        subCategoryKey: "off_road_and_rugged_systems",
        dataKey: "4wd_4x4_systems",
    },
];

export const COMPARE_UI_GROUP_ORDER = [
    "General",
    "Performance",
    "Safety",
    "Features",
] as const;

// Normalize a spec key: lowercase, spaces→underscores, strip parenthetical suffixes like (hp)/(abs)/(N.M)
function _normalizeKey(key: string): string {
    return key
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/\([^)]*\)/g, "")
        .replace(/_+$/g, "")
        .replace(/__+/g, "_");
}

// Lookup map: "categoryKey|subCategoryKey" → uiGroup (first match wins per pair)
const _subCatLookup = new Map<string, string>();
for (const row of COMPARE_SPEC_ROWS) {
    const key = `${row.categoryKey}|${row.subCategoryKey}`;
    if (!_subCatLookup.has(key)) {
        _subCatLookup.set(key, row.uiGroup);
    }
}

// Lookup map: normalized dataKey → uiGroup — handles DB variants like horse_power(hp) vs horse_power
const _dataKeyLookup = new Map<string, string>();
for (const row of COMPARE_SPEC_ROWS) {
    const normalized = _normalizeKey(row.dataKey);
    if (!_dataKeyLookup.has(normalized)) {
        _dataKeyLookup.set(normalized, row.uiGroup);
    }
}

// Lookup map: normalized dataKey → displayLabel
const _displayLabelLookup = new Map<string, string>();
for (const row of COMPARE_SPEC_ROWS) {
    const normalized = _normalizeKey(row.dataKey);
    if (!_displayLabelLookup.has(normalized)) {
        _displayLabelLookup.set(normalized, row.displayLabel);
    }
}

// Lookup map: "categoryKey" → uiGroup (first match wins per category, for fallback)
const _catLookup = new Map<string, string>();
for (const row of COMPARE_SPEC_ROWS) {
    if (!_catLookup.has(row.categoryKey)) {
        _catLookup.set(row.categoryKey, row.uiGroup);
    }
}

// Set of normalized known spec keys — used to filter out hallucinated/unknown fields
const _knownSpecKeys = new Set<string>(
    COMPARE_SPEC_ROWS.map((r) => _normalizeKey(r.dataKey)),
);

/** Returns true if the spec key (from saved vehicle data) is a recognized field in COMPARE_SPEC_ROWS. */
export function isKnownSpecKey(spec: string): boolean {
    return _knownSpecKeys.has(_normalizeKey(spec));
}

/**
 * Return the displayLabel for a spec dataKey, or null if the key is not in COMPARE_SPEC_ROWS.
 * Handles stored key variants (e.g. "horse_power(hp)" matches "horse_power").
 */
export function getDisplayLabel(dataKey: string): string | null {
    return _displayLabelLookup.get(_normalizeKey(dataKey)) ?? null;
}

/**
 * Resolve the uiGroup for a row given its categoryKey, subCategoryKey, and optionally the spec dataKey.
 * Lookup order: exact category|subCategory pair → normalized dataKey → category → "Other".
 */
export function getUiGroup(
    categoryKey: string,
    subCategoryKey: string,
    dataKey?: string,
): string {
    return (
        _subCatLookup.get(`${categoryKey}|${subCategoryKey}`) ??
        (dataKey !== undefined
            ? _dataKeyLookup.get(_normalizeKey(dataKey))
            : undefined) ??
        _catLookup.get(categoryKey) ??
        "Other"
    );
}
